import { createContext, useContext, useState } from "react";
import styles from './Header.module.css'
import { Link, useNavigate } from "react-router-dom";
import DisplayContext from "../../context/DisplayContext";
import Search from "../input/search/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const HeaderSearch = () => {
	const navigate = useNavigate()
	const [query, setQuery] = useState("")

	const search = () => navigate(`/search?q=${ query }`)

	return (
		<Search
			id={ styles['header-search-bar'] }
			onChange={ setQuery }
			action={ search }
			clearOnClick
		/>
	)
}

const CreateButton = () => {
	const navigate = useNavigate()

	const create = () => navigate("/create")

	return (
		<button id={ styles['create-btn'] } onClick={ create }>
			<FontAwesomeIcon icon={ ["far", "circle-plus"] } size='2x'/>
		</button>
	)
}

const Header = ({ isVertical }) => {
	const { isHeaderSearchEnabled } = useContext(DisplayContext)

	return (
		<header>
			<div id={ styles['header-left'] }>
				{ isVertical && <FontAwesomeIcon icon={ ["far", "bars"] } color="black" style={{paddingTop: "4px"}}/>}
				<Link to='/'>Bartender</Link>
			</div>
			<div id={ styles['header-right'] }>
				{ isHeaderSearchEnabled && <HeaderSearch/> }
				<CreateButton/>
			</div>
		</header>
	)
}

export default Header
